// Global Types
import type {
  $FullRegion,
  $Model,
} from 'common.data';

// Global Enums
import {
  ErrorKey,
} from 'common.enums';

// Helpers
import _ from 'lodash';
import moment from 'moment';
import {
  CustomError,
} from '@vroskus/library-error';
import {
  getDateTimeFormats,
} from './common';

export * from './common';

export const getConfig = <C extends Record<string, string>>({
  params,
}: {
  params: Array<keyof C>;
}): C => {
  const source = window || global;

  const config = _.get(
    source,
    'config',
  );

  if (typeof config !== 'undefined') {
    // @ts-expect-error config
    const output: C = {
    };

    params.forEach((param) => {
      _.set(
        output,
        param,
        config[param] || '',
      );
    });

    return output;
  }

  throw new CustomError(
    'Config not found',
    ErrorKey.configNotFound,
  );
};

export const getDateTimeString = ({
  RegionId,
  regions,
  value,
}: {
  RegionId: null | string;
  regions: Array<$FullRegion | $Model<'Region'>>;
  value?: Date | null | string;
}): string => {
  if (value) {
    const formats = getDateTimeFormats({
      RegionId,
      regions,
    });

    const dateTimeFormat = `${formats.Date} ${formats.Time}`;

    return moment(value).format(dateTimeFormat);
  }

  return '';
};
